import { Route, Redirect, useLocation } from "react-router-dom";
import { canAccess } from "./role-guard";
export default function ProtectedRoute({
  role,
  fallback = "/chats",
  ...routeProps
}) {
  const location = useLocation();
  const ok = canAccess(location.pathname, role);
  if (!ok) return <Redirect to={fallback} />;
  return <Route {...routeProps} />;
}
